import React from 'react'
import {Modal} from 'common/modals'
import {PostProvider} from 'context'
import {PostHeader, Photos, PostActions, PostBody, Comments} from 'common/Post'

/**
 * Instagram-style post detail: on desktop the media + text sit on the left (2/3)
 * and the comments on the right (1/3); on mobile they stack (post on top,
 * comments below) — the `col-lg-*` split handles both. A single `PostProvider`
 * feeds every sub-component (they read `PostContext`).
 */
export function PostDetailModal({post}: any) {
	return (
		<Modal size="xl">
			<PostProvider post={post}>
				<div className="modal-body p-0">
					<div className="row g-0">
						<div className="col-lg-8">
							<PostHeader />
							<Photos />
							<PostActions />
							<PostBody />
						</div>
						<div className="col-lg-4">
							<Comments />
						</div>
					</div>
				</div>
			</PostProvider>
		</Modal>
	)
}
